<template>
  <section>
    <el-row>
      <el-form label-width="80px">
        <el-form-item :label="$t('pages.logs.selectApp')" >
          <el-select v-model="inputParam.app_id" filterable>
            <el-option v-for="app in apps" :value="app.id" :label="app.name" :key="app.id"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item :label="$t('pages.logs.selectEvent')">
          <el-select v-model="inputParam.events" multiple filterable>
            <el-option v-for="event in allEvents" :value="event" :label="event" :key="event"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item  :label="$t('pages.logs.timeRange')">
          <el-date-picker v-model="inputParam.since" :placeholder="$t('pages.logs.startDate')"></el-date-picker>
          <span> {{ $t('common.to') }} </span>
          <el-date-picker v-model="inputParam.until" :placeholder="$t('pages.logs.endDate')"></el-date-picker>
        </el-form-item>

        <el-form-item>
          <el-button @click="searchLogs" type="primary">{{ $t('pages.logs.search') }}</el-button>
        </el-form-item>
      </el-form>
    </el-row>

    <el-row>
      <el-table
        :data="logs"
        @sort-change="sortChange"
        :default-sort = "{ prop: 'created_at', order: 'descending' }">
        <div slot="empty">
          <template v-if="!fetchLogsError">
            <span>暂无数据</span>
          </template>
          <template v-else>
            <span>加载失败，请点击</span>
            <el-button
              type="text"
              @click="searchLogs">重试</el-button>
          </template>
        </div>
        <el-table-column
          prop="id"
          width="100"
          :label="$t('pages.logs.id')"
          sortable="custom">
        </el-table-column>
        <el-table-column
          prop="app_name"
          :label="$t('pages.logs.app_name')"
          sortable="custom">
        </el-table-column>
        <el-table-column
          prop="username"
          :label="$t('pages.logs.username')"
          sortable="custom">
        </el-table-column>
        <el-table-column
          prop="event"
          min-width="120"
          :label="$t('pages.logs.event')">
        </el-table-column>
        <el-table-column
          prop="extra"
          :label="$t('pages.logs.extra')"
          min-width="200">
          <template slot-scope="scope"  prop="extra" :label="$t('pages.logs.extra')">
            <pre style="word-wrap: break-word; white-space: pre-wrap" v-if="Object.keys(scope.row.extra).length !== 0">{{scope.row.extra}}</pre>
          </template>
        </el-table-column>
        </el-table-column>
        <el-table-column
          prop="ip"
          min-width="120"
          :label="$t('pages.logs.ip')"
          sortable="custom">
        </el-table-column>
        <el-table-column
          prop="created_at"
          :label="$t('pages.logs.created_at')"
          sortable="custom"
          :formatter="formatDatetime"
          width="160"
          align="center">
        </el-table-column>
      </el-table>
    </el-row>
    <el-row>
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-sizes="pageSizes" :page-size="inputParam.count" :current-page="inputParam.page" layout="sizes, prev, pager, next" :total="totalLogs"></el-pagination>
    </el-row>
  </section>
</template>

<script>
  export default {
    data() {
      const d = new Date();
      const oneMonthAgo = d.setMonth(d.getMonth() - 1);
      return {
        allEvents: [],
        inputParam: {
          app_id: '',
          since: oneMonthAgo,
          until: new Date(),
          events: [],
          orderby: '-created_at',
          page: 1,
          count: 50,
        },
        totalLogs: 0,
        pageSizes: [20, 50, 100],
        apps: [],
        logs: [],
        fetchLogsError: false,
      };
    },
    computed: {
      searchParam() {
        const searchParam = {};
        if (this.inputParam.app_id) searchParam.app_id = parseInt(this.inputParam.app_id, 10);
        if (this.inputParam.events.length > 0) searchParam.events = this.inputParam.events.join(',');
        if (this.inputParam.since) {
          searchParam.since = parseInt(this.inputParam.since.valueOf() / 1000, 10);
        }
        if (this.inputParam.until) {
          searchParam.until = parseInt(this.inputParam.until.valueOf() / 1000, 10);
        }
        searchParam.page = this.inputParam.page;
        searchParam.count = this.inputParam.count;
        searchParam.orderby = this.inputParam.orderby;
        return searchParam;
      },
    },
    methods: {
      formatDatetime(r, c) {
        const ds = r[c.property];
        return ds ? this.$moment(ds).utcOffset(+960).format('YYYY/M/DD HH:mm:ss') : '';
      },
      searchLogs() {
        this.fetchLogsError = false;
        this.$api.searchLogs(this.searchParam)
          .then((res) => {
            const pager = res.data.pager;
            this.logs = res.data.logs;
            this.totalLogs = pager.total;
          })
          .catch(() => {
            this.fetchLogsError = true;
            this.logs = [];
            this.totalLogs = 0;
          });
      },
      fetchApps() {
        this.$api.listApps().then((res) => {
          this.apps = res.data.applications;
        });
      },
      fetchEvents() {
        this.$api.fetchEvents().then((res) => {
          this.allEvents = res.data.events;
        });
      },
      handleSizeChange(s) {
        this.searchParam.count = s;
        this.searchParam.page = 1;
        this.searchLogs();
      },
      handleCurrentChange(p) {
        this.searchParam.page = p;
        this.searchLogs();
      },
      sortChange(event) {
        let prop = event.prop;
        if (prop === 'username') prop = 'user_id';
        if (prop === 'app_name') prop = 'app_id';
        const order = event.order;
        const prefix = order === 'descending' ? '-' : '';
        this.searchParam.orderby = `${prefix}${prop}`;
        this.searchLogs();
      },
    },
    created() {
      this.fetchEvents();
      this.fetchApps();
      this.searchLogs();
    },
  };
</script>



// WEBPACK FOOTER //
// Logs.vue?5fd3cbb0